<template>
    <div>
        <el-alert
            :closable="false"
            class="mb-2"
            :title="$t.__('developerPage.WebhooksForms.Webhooks.WebhookSlack.add_webhook_error')"
            type="success"
        >
        </el-alert>
        <div v-if="loading" class="prelative mt-4">
            <preloader :background="false" :display="loading" />
        </div>
        <webhooks-form-template v-else :logs="logs" :form="form" :rules="rules" @submit="submit">
            <template #endpoint>
                <el-form-item prop="name" :error="errors.name">
                    <template #label>
                        <span class="gray-100">
                            {{ $l10n.__('Nom du webhook') }}
                        </span>
                    </template>
                    <div class="flex-row ai-center">
                        <el-input v-model="form.name"></el-input>
                    </div>
                </el-form-item>

                <el-form-item prop="endpoint" :error="errors.endpoint">
                    <template #label
                        ><span class="gray-100">
                            {{ $l10n.__('Endpoint Slack') }}
                        </span></template
                    >
                    <div class="flex-row ai-center">
                        <i class="icon-link mr-2"></i>
                        <el-input v-model="form.endpoint"></el-input>
                    </div>
                </el-form-item>
                <el-form-item class="mb-0" prop="default_channel" :error="errors.default_channel">
                    <template #label
                        ><span class="gray-100">
                            {{ $l10n.__('Channel Slack par défaut') }}
                        </span></template
                    >
                    <div class="flex-row ai-center">
                        <i class="fa fa-15 fa-slack mr-2"></i>
                        <el-input v-model="form.default_channel" class="wp-5"></el-input>
                    </div>
                </el-form-item>
                <div>
                    <el-checkbox v-model="form.is_enabled">{{
                        $l10n.__('Webhook actif ?')
                    }}</el-checkbox>
                </div>
            </template>
            <template #configDescription>
                <p class="mt-2 mb-4">
                    {{
                        $l10n.__(
                            'Vous pouvez personnaliser pour chaque notification le channel Slack.',
                        )
                    }}
                </p>
            </template>
            <template #tagEvents="scopeEvents">
                {{ activeEvents(scopeEvents.currentLog.id) }} /
                {{ getAllEventsForParentLog(scopeEvents.currentLog.id).length }}
            </template>
            <!-- Logs events -->
            <template #events="scope">
                <div>
                    <el-table :data="getEventsConfigByLog(scope.log.id)" class="b-1" stripe>
                        <el-table-column prop="label" width="390">
                            <template #header>
                                <span class="regular">
                                    {{ getTableTitleByLog(scope.log) }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column label="Channel">
                            <template #default="scope">
                                <div class="flex-level">
                                    <i class="fa fa-15 fa-slack mr-2"></i>
                                    <el-input v-model="scope.row.channel"></el-input>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            :label="$t.__('developerPage.WebhooksForms.Webhooks.activated')"
                            width="65"
                        >
                            <template #default="scopeEnabled">
                                <el-switch
                                    :modelValue="scopeEnabled.row.is_enabled"
                                    @input="(e) => handleSwitch(e, scopeEnabled.row)"
                                ></el-switch>
                            </template>
                        </el-table-column>
                    </el-table>

                    <!-- Child events to main Log -->
                    <div v-for="childLog of getLogsChildByLog(scope.log.id)" :key="childLog.id">
                        <el-table :data="getEventsConfigByLog(childLog.id)" class="b-1" stripe>
                            <el-table-column prop="label" width="390">
                                <template #header>
                                    <span class="regular">
                                        {{ getTableTitleByLog(childLog) }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column label="Channel">
                                <template #default="scope">
                                    <div class="flex-level">
                                        <i class="fa fa-15 fa-slack mr-2"></i>
                                        <el-input v-model="scope.row.channel"></el-input>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                :label="$t.__('developerPage.WebhooksForms.Webhooks.activated')"
                                width="65"
                            >
                                <template #default="scopeEnabled">
                                    <el-switch
                                        :modelValue="scopeEnabled.row.is_enabled"
                                        @input="(e) => handleSwitch(e, scopeEnabled.row)"
                                    ></el-switch>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </template>
        </webhooks-form-template>
    </div>
</template>
<script>
import WebhooksFormTemplate from 'vcomponents/developerPage/WebhooksForms/WebhooksFormTemplate.vue';
import WebhooksMixins from 'vcomponents/developerPage/WebhooksForms/WebhooksMixins';
export default {
    components: {
        WebhooksFormTemplate,
    },
    mixins: [WebhooksMixins],
    created() {
        delete this.form.object_in_payload;
        delete this.form.json_content_type;
        delete this.form.sign_key;
        this.form = {
            ...this.form,
            default_channel: '',
        };

        this.rules.endpoint[0] = {
            ...this.rules.endpoint[0],
            pattern: /^https?:\/\/hooks.slack.com\/services\/T[\S]{8,}\/B[\S]{8,}\/[\S]{24}$/,
            message: this.$l10n.__('Veuillez renseigner un endpoint Slack valide'),
        };
        this.rules.default_channel = [
            {
                required: true,
                type: 'string',
                message: this.$l10n.__('Veuillez renseigner un Channel Slack par défaut valide'),
            },
        ];
    },
};
</script>
